module.exports = __webpack_public_path__ + "img/left_white.91acbf66.svg";